import { Navbar, Nav, Container } from 'react-bootstrap';
import "../Assests/navbar.css";




const Navigation =() =>{
    return(
    <>
    <Navbar sticky="top"  collapseOnSelect  expand="sm" bg="dark" varient="dark">
        <Container>
           
            <Navbar.Toggle  aria-controls="responsive-navbar-nav"></Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="flex-gap">
                    
                    <Nav.Link href='/about'><p className="navlink">About</p></Nav.Link>
                    
                    <Nav.Link href='/projects'><p className="navlink">Projects</p></Nav.Link>
                    
                    
                 
                    
                    <Nav.Link href='/contact'><p className="navlink">Contact</p></Nav.Link>
                    
                    
                  
                    
                </Nav>
            </Navbar.Collapse>
            
        </Container>
    </Navbar>
    </>
    );
}
export default Navigation;